import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: "nge-mw-sheet",
  role: "dialog",
  "aria-label": "EyeWire II on mobile"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "nge-mw-handle" }, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "nge-mw-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "nge-mw-kicker" }, "MOBILE UPLINK · LIMITED BANDWIDTH", -1 /* HOISTED */)
const _hoisted_6 = { class: "nge-mw-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "nge-mw-copy" }, " The full EyeWire II brain mapping interface needs a bigger screen. But your phone still has partial clearance. Start here: ", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-icon" }, "🧠", -1 /* HOISTED */)
const _hoisted_9 = { class: "nge-mw-learn-text" }
const _hoisted_10 = { class: "nge-mw-learn-title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-sub" }, "Neuroscience 101", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-arrow" }, "›", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-icon nge-mw-learn-icon--svg" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    class: "nge-mw-net",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "#18cfff",
      "stroke-linecap": "round",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M5 6 L12 4 M12 4 L19 7 M5 6 L11 12 M12 4 L11 12 M19 7 L11 12",
        "stroke-width": "1.1",
        opacity: "0.55"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11 12 L4 15 M11 12 L18 17 M4 15 L9 20 M9 20 L18 17 M11 12 L9 20",
        "stroke-width": "1.1",
        opacity: "0.45"
      })
    ]),
    /*#__PURE__*/_createElementVNode("g", { fill: "#4ad8ff" }, [
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "5",
        cy: "6",
        r: "1.6",
        opacity: "0.85"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "12",
        cy: "4",
        r: "1.4",
        opacity: "0.75"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "19",
        cy: "7",
        r: "1.5",
        opacity: "0.8"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "4",
        cy: "15",
        r: "1.4",
        opacity: "0.7"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "18",
        cy: "17",
        r: "1.6",
        opacity: "0.8"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "9",
        cy: "20",
        r: "1.3",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "11",
        cy: "12",
        r: "2.5",
        fill: "#8ceaff"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-title" }, "What is a connectome?"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-sub" }, "The greatest map humans have ever drawn")
], -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mw-learn-arrow" }, "›", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "nge-mw-divider" }, [
  /*#__PURE__*/_createElementVNode("span", null, "SYSTEMS AVAILABLE ON YOUR PHONE")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "nge-mw-sys-list" }
const _hoisted_18 = { class: "nge-mw-sys-icon" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "nge-mw-sys-text" }
const _hoisted_21 = { class: "nge-mw-sys-label" }
const _hoisted_22 = {
  key: 0,
  class: "nge-mw-sys-go"
}
const _hoisted_23 = { class: "nge-mw-sys-sub" }
const _hoisted_24 = {
  key: 0,
  class: "nge-mw-verifying"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "nge-mw-divider" }, [
  /*#__PURE__*/_createElementVNode("span", null, "CITIZEN SCIENCE MOBILE PORTAL")
], -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "nge-mw-cta-sub" }, "Become a citizen scientist · free · full access", -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "nge-mw-divider" }, [
  /*#__PURE__*/_createElementVNode("span", null, "RECRUIT MORE SCIENTISTS")
], -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "17",
  height: "17",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17.5 3h3.2l-7 8 8.2 10h-6.4l-5-6.5L4.7 21H1.5l7.5-8.5L1.2 3h6.6l4.5 6zm-1.1 16.2h1.8L7.7 4.7H5.8z" })
], -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Post", -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 7h3V4h-3c-1.93 0-3.5 1.57-3.5 3.5V10H8v3h2.5v8h3v-8H16l1-3h-3.5V7.5c0-.28.22-.5.5-.5z" })
], -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Share", -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.5 6.5l8.5 6.5 8.5-6.5" })
], -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "Email", -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Teleported: .ng-extend's `button { display:inline-block; font:inherit }`\n       cascade must not reach the sheet's own components. "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "nge-mw" }, {
        default: _withCtx(() => [
          ($props.show)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-mw-blocker",
                onClick: _withModifiers($setup.dismiss, ["self"])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("button", {
                    class: "nge-mw-close",
                    onClick: $setup.dismiss,
                    title: "Close"
                  }, "×"),
                  _createCommentVNode(" ── Home ── "),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "nge-mw-spin-stage",
                      "aria-hidden": "true",
                      onPointerdown: $setup.spinStart,
                      onPointermove: $setup.spinMove,
                      onPointerup: $setup.spinEnd,
                      onPointercancel: $setup.spinEnd
                    }, [
                      _createElementVNode("div", {
                        class: "nge-mw-spin",
                        style: _normalizeStyle({ transform: `rotateX(8deg) rotateY(${$setup.spinAngle}deg)` })
                      }, [
                        _createVNode($setup["NeuronGlyph"])
                      ], 4 /* STYLE */)
                    ], 32 /* HYDRATE_EVENTS */),
                    _hoisted_5,
                    _createElementVNode("h2", _hoisted_6, _toDisplayString($setup.greeting), 1 /* TEXT */),
                    _hoisted_7,
                    _createElementVNode("button", {
                      class: "nge-mw-learn",
                      onClick: $setup.openLearn
                    }, [
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, [
                        _createCommentVNode(" The playful \"anyway\" is for strangers; players get the tidy title. "),
                        _createElementVNode("span", _hoisted_10, _toDisplayString($props.loggedIn ? 'What is a brain?' : 'What is a brain anyway?'), 1 /* TEXT */),
                        _hoisted_11
                      ]),
                      _hoisted_12
                    ]),
                    _createElementVNode("button", {
                      class: "nge-mw-learn",
                      onClick: $setup.openAtlas
                    }, [
                      _createCommentVNode(" Connectomics, not arachnids: a wiring diagram — neurons as\n                 nodes, synaptic connections as edges (Amy 2026-08-25). "),
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15
                    ]),
                    _hoisted_16,
                    _createCommentVNode(" Typography before login (systems unlock after auth); once\n               logged in each row is a live link into its panel. "),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.SYSTEMS, (sys) => {
                        return _createVNode(_resolveDynamicComponent($props.loggedIn ? 'button' : 'div'), {
                          key: sys.id,
                          class: _normalizeClass(["nge-mw-sys", { 'nge-mw-sys--link': $props.loggedIn }]),
                          onClick: $event => ($props.loggedIn && $setup.openPanel(sys.id))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_18, [
                              (sys.id === 'cells')
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: $setup.neuronIcon,
                                    class: "nge-mw-neuron-icon",
                                    alt: ""
                                  }, null, 8 /* PROPS */, _hoisted_19))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(sys.icon), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                            ]),
                            _createElementVNode("span", _hoisted_20, [
                              _createElementVNode("span", _hoisted_21, [
                                _createTextVNode(_toDisplayString(sys.label), 1 /* TEXT */),
                                ($props.loggedIn)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, " ›"))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(sys.sub), 1 /* TEXT */)
                            ])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "onClick"])
                      }), 64 /* STABLE_FRAGMENT */))
                    ]),
                    _createCommentVNode(" Logged out: the mission invite IS the login path. Logged in:\n               an explicit status row instead — the sheet always shows where\n               you stand with the login system, never a silent gap. Until\n               the token check settles, neither: a quiet verifying line, so\n               the login button never flashes in and then vanishes. "),
                    (!$props.loginChecked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, "VERIFYING CLEARANCE…"))
                      : (!$props.loggedIn)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_25,
                            _createElementVNode("p", { class: "nge-mw-invite" }, _toDisplayString($setup.PORTAL_LINE)),
                            _createCommentVNode(" Straight into the Google auth popup (via nge:request-login in\n                 ExtensionBar/LoginModal) — no second Log in tap on the\n                 Identity Verification box. "),
                            _createElementVNode("button", {
                              class: "nge-mw-cta",
                              onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('login')))
                            }, " 🔐 LOG IN WITH GOOGLE "),
                            _hoisted_26
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "nge-mw-signed",
                            onClick: _cache[1] || (_cache[1] = $event => ($setup.openPanel('profile')))
                          }, [
                            _createTextVNode(" ✓ CITIZEN SCIENTIST ON DUTY"),
                            ($props.userName)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString($props.userName.toUpperCase()), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ])),
                    _hoisted_27,
                    _createElementVNode("div", { class: "nge-mw-share" }, [
                      _createElementVNode("button", {
                        onClick: $setup.shareX,
                        title: "Post to X"
                      }, _hoisted_30),
                      _createElementVNode("button", {
                        onClick: $setup.shareFacebook,
                        title: "Share to Facebook"
                      }, _hoisted_33),
                      _createElementVNode("button", {
                        onClick: $setup.shareEmail,
                        title: "Email a link"
                      }, _hoisted_36)
                    ]),
                    _createElementVNode("button", {
                      class: "nge-mw-bypass",
                      onClick: $setup.dismiss
                    }, " JUST EXPLORING · ENTER THE FULL COCKPIT › "),
                    _createElementVNode("button", {
                      class: "nge-mw-bypass nge-mw-tour-link",
                      onClick: _cache[2] || (_cache[2] = $event => ($setup.emit('tour')))
                    }, " TAKE THE TOUR › ")
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_1))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}